import { ButtonModule } from 'primeng/button';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ViewChild,
  inject,
  signal,
} from '@angular/core';

import { autoUpdate, computePosition, flip, offset, Placement, shift } from '@floating-ui/dom';
import { MessageModule } from 'primeng/message';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'nutrix-ui-dropdown',
  imports: [MessageModule, ButtonModule],
  templateUrl: './ui-dropdown.component.html',
  styleUrl: './ui-dropdown.component.css',
})
export class UiDropdownComponent implements AfterViewInit {
  readonly #messageService = inject(MessageService);
  protected readonly open = signal<boolean>(false);
  @ViewChild('dropdown') public dropdown!: ElementRef;
  @ViewChild('button', { read: ElementRef }) public button!: ElementRef;
  @Input() public position: Placement = 'right-start';
  toggle() {
    this.open.update((v) => !v);
    this.calculatePosition();
  }
  @Output() public leave = new EventEmitter<boolean>(false);
  @Output() public settings = new EventEmitter<boolean>(false);

  @HostBinding('class') get class() {
    const extraClasses = 'inline-flex items-center';
    return extraClasses;
  }
  protected x = 0;
  protected y = 0;
  protected width = 0;

  private calculatePosition() {
    computePosition(this.button.nativeElement, this.dropdown.nativeElement, {
      placement: this.position,
      middleware: [offset(8), flip(), shift()],
    })
      .then(({ x, y }: { x: number; y: number }) => {
        this.dropdown.nativeElement.style.left = x + 'px';
        this.dropdown.nativeElement.style.top = y + 'px';
        this.width = this.button.nativeElement.offsetWidth;
      })
      .catch((error) => this.#messageService.add({ severity: 'error', detail: error.message }));
  }

  public ngAfterViewInit(): void {
    autoUpdate(this.button.nativeElement, this.dropdown.nativeElement, () => {
      if (!this.open()) return;
      this.calculatePosition();
    });
  }

  // Onclick outside the dropdown, close it
  @HostListener('document:click', ['$event'])
  public clickout(event: Event): void {
    if (
      !this.dropdown.nativeElement.contains(event.target) &&
      this.open() &&
      !this.button.nativeElement.contains(event.target)
    ) {
      this.open.set(false);
    }
  }
}
